import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SearchBar from '../components/SearchBar';
import HotelCard from '../components/HotelCard';
import './Home.css';

const DESTINATIONS = [
  { city: 'Bali', country: 'Indonesia', emoji: <i className="fa-brands fa-periscope" style={{color:'white'}}></i>, img: 'https://images.unsplash.com/photo-1537953773345-d172ccf13cf1?w=500' },
  { city: 'Paris', country: 'France', emoji: <i className="fa-brands fa-periscope" style={{color:'white'}}></i>, img: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=500' },
  { city: 'Tokyo', country: 'Japan', emoji: <i className="fa-brands fa-periscope" style={{color:'white'}}></i>, img: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=500' },
  { city: 'Santorini', country: 'Greece', emoji: <i className="fa-brands fa-periscope" style={{color:'white'}}></i>, img: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=500' },
  { city: 'Dubai', country: 'UAE', emoji: <i className="fa-brands fa-periscope" style={{color:'white'}}></i>, img: 'https://images.unsplash.com/photo-1506059612708-99d6c258160e?w=500' },
  { city: 'Maldives', country: 'Maldives', emoji: <i className="fa-brands fa-periscope" style={{color:'white'}}></i>, img: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=500' },
];

const PROPERTY_TYPES = [
  { type: 'hotel', icon: <i class="fa-solid fa-archway"></i>, label: 'Hotels' },
  { type: 'resort', icon: <i class="fa-solid fa-umbrella-beach"></i>, label: 'Resorts' },
  { type: 'villa', icon: <i class="fa-solid fa-mountain-city"></i>, label: 'Villas' },
  { type: 'boutique', icon: <i class="fa-solid fa-shop"></i>, label: 'Boutique' },
  { type: 'apartment', icon: <i class="fa-solid fa-building"></i>, label: 'Apartments' },
];

const Home = () => {
  const [featuredHotels, setFeaturedHotels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const res = await axios.get('/api/hotels?featured=true&limit=6');
        setFeaturedHotels(res.data.hotels);
      } catch (err) {
        console.error('Error fetching hotels:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchFeatured();
  }, []);

  return (
    <div className="home">
      <Navbar />

      {/* Hero */}
      <section className="hero">
        <div className="hero-bg">
          <img src="https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=1800" alt="Hero" />
          <div className="hero-overlay" />
        </div>
        <div className="hero-content container">
          <h1 className="hero-title">
            Find Your Perfect<br />
            <em>Home Away From Home</em>
          </h1>
          <p className="hero-subtitle">
            Discover hotels, resorts, and villas across the world's most breathtaking destinations
          </p>
          <div className="hero-search">
            <SearchBar />
          </div>
          {/* <div className="hero-stats">
            <div className="stat"><span className="stat-num">10K+</span><span className="stat-label">Properties</span></div>
            <div className="stat-divider" />
            <div className="stat"><span className="stat-num">180+</span><span className="stat-label">Countries</span></div>
            <div className="stat-divider" />
            <div className="stat"><span className="stat-num">2M+</span><span className="stat-label">Happy Guests</span></div>
            <div className="stat-divider" />
            <div className="stat"><span className="stat-num">4.9★</span><span className="stat-label">Average Rating</span></div>
          </div> */}
        </div>
        <div className="hero-scroll-hint">
          <span>Scroll to explore</span>
          <div className="scroll-arrow">↓</div>
        </div>
      </section>

      {/* Property Types */}
      <section className="section section-types container">
        <div className="section-header">
          {/* <span className="section-tag">Browse by Type</span> */}
          <h2 className="section-title">What Are You Looking For?</h2>
          <p className="section-sub">From romantic hideaways to family resorts, we have something for every kind of traveller</p>
        </div>
        <div className="types-grid">
          {PROPERTY_TYPES.map(({ type, icon, label }) => (
            <Link to={`/hotels?type=${type}`} key={type} className="type-card">
              <span className="type-icon">{icon}</span>
              <span className="type-label">{label}</span>
              <span className="type-arrow">→</span>
            </Link>
          ))}
        </div>
      </section>

      {/* Featured Hotels */}
      <section className="section section-featured">
        <div className="container">
          <div className="section-header">
            {/* <span className="section-tag">Handpicked</span> */}
            <h2 className="section-title">Featured Stays</h2>
            <p className="section-sub">Exceptional properties selected by our travel experts</p>
          </div>
          {loading ? (
            <div className="page-loader"><div className="spinner" /></div>
          ) : (
            <div className="hotels-grid">
              {featuredHotels.map(hotel => (
                <HotelCard key={hotel._id} hotel={hotel} />
              ))}
            </div>
          )}
          <div className="section-cta">
            <Link to="/hotels" className="btn btn-dark btn-lg">
              View All Properties 
            </Link>
          </div>
        </div>
      </section>

      {/* Top Destinations */}
      <section className="section section-destinations container">
        <div className="section-header">
          {/* <span className="section-tag">Trending</span> */}
          <h2 className="section-title">Top Destinations</h2>
          <p className="section-sub">The world's most sought-after travel spots right now</p>
        </div>
        <div className="destinations-grid">
          {DESTINATIONS.map((dest) => (
            <Link
              to={`/hotels?city=${dest.city}`}
              key={dest.city}
              className="destination-card"
            >
              <img src={dest.img} alt={dest.city} loading="lazy" />
              <div className="dest-overlay" />
              <div className="dest-info">
                <span className="dest-emoji">{dest.emoji}</span>
                <h3 className="dest-city">{dest.city}</h3>
                <p className="dest-country">{dest.country}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section section-why">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Why Roamio</span>
            <h2 className="section-title">Travel Smarter, Stay Better</h2>
          </div>
          <div className="why-grid">
            {[
              { icon: <i class="fa-solid fa-filter"></i>, title: 'Curated Selection', desc: 'Every property is hand-verified by our expert team to ensure exceptional quality and authenticity.' },
              { icon: <i class="fa-solid fa-coins"></i>, title: 'Best Price Guarantee', desc: 'We match any lower price you find. No hidden fees, transparent pricing from the start.' },
              { icon: <i class="fa-solid fa-globe"></i>, title: 'Global Coverage', desc: 'Over 10,000 properties across 180+ countries, from remote hideaways to city-centre hotels.' },
              { icon: <i class="fa-solid fa-concierge-bell"></i>, title: '24/7 Support', desc: 'Our dedicated concierge team is always available to assist you, wherever you are in the world.' },
            ].map(({ icon, title, desc }) => (
              <div key={title} className="why-card">
                <div className="why-icon">{icon}</div>
                <h3 className="why-title">{title}</h3>
                <p className="why-desc">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="section-cta-banner">
        <div className="container">
          <div className="cta-banner">
            <div className="cta-banner-bg" />
            <div className="cta-content">
              <h2>Ready to Start Your Journey?</h2>
              <p>Join over 2 million travellers who trust Roamio for their perfect stay</p>
              <div className="cta-btns">
                <Link to="/register" className="btn btn-primary btn-lg">Create Free Account</Link>
                <Link to="/hotels" className="btn btn-ghost btn-lg">Browse Hotels</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
